// extracted by mini-css-extract-plugin
export var cancelButton = "_r2-5";
export var content = "_r2-3";
export var createButton = "_r2-6";
export var drawerContainer = "_r2-0";
export var footer = "_r2-2";
export var header = "_r2-1";
export var orderFormColumn = "_r2-4";